import { createSelector } from 'reselect';

import {
  // Frame
  toggleSidebarSelector,
  // Navigation
  navigationHomeSelector,
  navigationMessagesSelector,
  navigationContactsSelector,
  navigationJobsSelector,
  navigationMenuSelector,
  // Props
  localeSelector,
} from '../../../selectors';
import { localizedLink } from '../../../selectors/utils';

export default createSelector(
  localeSelector,
  navigationHomeSelector,
  navigationMessagesSelector,
  navigationContactsSelector,
  navigationJobsSelector,
  navigationMenuSelector,
  toggleSidebarSelector,
  (locale, home, messages, contacts, jobs, menu, toggleSidebar) => {
    const localizedFunc = localizedLink(locale);
    return [home, messages, contacts, jobs].map(localizedFunc).concat([
      {
        ...menu,
        // Add toggleSidebar to Menu
        toggleSidebar,
      },
    ]);
  }
);
